import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../config/api';
import './UploadImages.css';

const UploadImages = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);


  const handleSingleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleMultipleFilesChange = (e) => {
    setSelectedFiles(Array.from(e.target.files));
  };

  const handleSingleUpload = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      toast.error('Please select a file');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('image', selectedFile);

    try {
      const response = await axios.post(`${API_URL}/api/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success('Image uploaded successfully!');
      setUploadedImages([...uploadedImages, response.data.data]);
      setSelectedFile(null);
      document.getElementById('single-file').value = '';
    } catch (error) {
      toast.error(error.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const handleMultipleUpload = async (e) => {
    e.preventDefault();
    if (selectedFiles.length === 0) {
      toast.error('Please select at least one file');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append('images', file);
    });

    try {
      const response = await axios.post(`${API_URL}/api/upload/multiple`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      toast.success(`${response.data.count} images uploaded successfully!`);
      setUploadedImages([...uploadedImages, ...response.data.data]);
      setSelectedFiles([]);
      document.getElementById('multiple-files').value = '';
    } catch (error) {
      toast.error(error.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="container">
      <h1>Upload Images</h1>

      <div className="card">
        <h2>Single Image Upload</h2>
        <form onSubmit={handleSingleUpload}>
          <div className="form-group">
            <label>Select Image</label>
            <input
              id="single-file"
              type="file"
              accept="image/*"
              onChange={handleSingleFileChange}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={uploading}>
            {uploading ? 'Uploading...' : 'Upload Image'}
          </button>
        </form>
      </div>

      <div className="card">
        <h2>Multiple Images Upload</h2>
        <form onSubmit={handleMultipleUpload}>
          <div className="form-group">
            <label>Select Images (up to 10)</label>
            <input
              id="multiple-files"
              type="file"
              accept="image/*"
              multiple
              onChange={handleMultipleFilesChange}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={uploading}>
            {uploading ? 'Uploading...' : 'Upload Images'}
          </button>
        </form>
      </div>

      {uploadedImages.length > 0 && (
        <div className="card">
          <h2>Uploaded Images</h2>
          <div className="image-grid">
            {uploadedImages.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image.url} alt={`Uploaded ${index + 1}`} />
                <p className="image-url">{image.url}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadImages;

